import { updateContext, removeContext, clearUser } from '@mindtickle/ui-shell-core/Datadog';

const useDatadogHelpers = () => ({
  updateContext,
  removeContext,
  clearUser,
});

export default useDatadogHelpers;
